var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({staticClass:"form-checkbox focus:ring-opacity-light-green h-4 w-4 text-accent-dark-green border border-solid border-medium-grey-100 rounded",attrs:{"type":"checkbox"}},'input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }